<div [ngClass]="{ 'background' : !hiringCertificate}">
  <div class="container" *ngIf="businessData && !hiringCertificate">
    <div class="row">
      <div class="col-lg-10 offset-md-1 all-card">
        <div class="contact-info valid-info shadow mb-5">
          <!-- fc relased -->
          <div class="row">
            <div class="col-md-6">
              <div class="mb-4">
                <img src="assets/images/valid.png" *ngIf="businessData.cnss_status == 1">
                <img src="assets/images/pending.png" *ngIf="businessData.cnss_status == 0">
                <img src="assets/images/resub.png" *ngIf="businessData.cnss_status == 5">
                <img src="assets/images/rejected.png" *ngIf="businessData.cnss_status == 4">
                <p class="mt-3">Nº CNSS : {{ businessData.cnss }}</p>
                <span class="anpi_green" *ngIf="businessData.cnss_status == 1">Entreprise vérifiée CNSS</span>
                <span class="anpi_yellow" *ngIf="businessData.cnss_status == 0">Entreprise vérifiée en attente CNSS</span>
                <span class="anpi_red" *ngIf="businessData.cnss_status == 4">Entreprise vérifiée Rejeté CNSS</span>
                <span class="anpi_resubmitted" *ngIf="businessData.cnss_status == 5">Entreprise vérifiée Soumis à nouveau CNSS</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-4">
                <img src="assets/images/valid.png" *ngIf="businessData.cnamgs_status == 1">
                <img src="assets/images/pending.png" *ngIf="businessData.cnamgs_status == 0">
                <img src="assets/images/resub.png" *ngIf="businessData.cnamgs_status == 5">
                <img src="assets/images/rejected.png" *ngIf="businessData.cnamgs_status == 4">
                <p class="mt-3">Nº CNAMGS : {{ businessData.cnamgs }}</p>
                <span class="anpi_green" *ngIf="businessData.cnamgs_status == 1">Entreprise vérifiée CNAMGS</span>
                <span class="anpi_yellow" *ngIf="businessData.cnamgs_status == 0">Entreprise vérifiée en attente CNAMGS</span>
                <span class="anpi_red" *ngIf="businessData.cnamgs_status == 4">Entreprise vérifiée Rejeté CNAMGS</span>
                <span class="anpi_resubmitted" *ngIf="businessData.cnamgs_status == 5">Entreprise vérifiée Soumis à nouveau CNAMGS</span>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <h5 class="mb-1">{{ businessData.name }}</h5>
            <h4>Nº ANPI : {{ businessData.anpi_code }}</h4>
          </div>
          <h6>Date de création : {{ businessData.created_date }}</h6>
          <div class="mt-5">
            <h6>Forme juridique</h6>
            <p>{{ businessData.legal_status}}</p>
            <h6>Le nom du propriétaire</h6>
            <p>{{ businessData.owner_full_name }}</p>
            <h6>Téléphone</h6>
            <p>{{ businessData.owner_phone }}</p>
            <h6>E-mail</h6>
            <p>{{ businessData.owner_email }}</p>
            <h6>Date de début de service</h6>
            <p>{{ businessData.service_start_date }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container hiring-certificate" *ngIf="businessData && hiringCertificate">
    <div class="row">
      <div class="col-lg-10 offset-md-1 all-card">
        <div class="contact-info valid-info shadow mb-5">
          <!-- fc relased -->
          <div class="mb-3">
            <h5 class="mb-4">{{ businessData.company_name }}</h5>
            <div class="mb-2">
              <img [src]="businessData.image" alt="employee photo">
            </div>
            <h4>Nom et prénom : {{ businessData.full_name }}</h4>
          </div>
          <h6>Date de naissance: {{ businessData.dob }}</h6>
          <div class="mt-5">
            <h6>Téléphone</h6>
            <p>{{ businessData.mobile}}</p>
            <h6>E-mail</h6>
            <p>{{ businessData.email}}</p>
            <h6>Nº PUPS</h6>
            <p>{{ businessData.ccps_code}}</p>
            <h6>Nº CNSS</h6>
            <p>{{ businessData.cnss_code}}</p>
            <h6>Poste occupé</h6>
            <p class="text-capitalize">{{ businessData.designation }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="businessData == false">
    <div class="row">
      <div class="col-lg-10 offset-md-1 all-card">
        <div class="contact-info valid-info shadow mb-5">
          <img src="assets/images/not-valid.png">
          <span *ngIf="!hiringCertificate" class="anpi_green">Ce n'est pas une entreprise vérifiée</span>
          <h5 *ngIf="!hiringCertificate" class="mb-3">Désolé, cette entreprise n'est pas vérifiée</h5>
          <h5 *ngIf="hiringCertificate" class="mb-3">Désolé, cet employé n'est pas vérifié</h5>
        </div>
      </div>
    </div>
  </div>
  <section>
    <div class="container">
      <div class="row">
        <div class="col-lg-6 offset-md-3">
          <div class="validate-form">
            <h3>Si vous avez des questions, veuillez nous contacter</h3>
          </div>
          <div class="contact-info shadow mb-5">
            <h5 class="mb-3">PUPS-GABON</h5>
            104 Rue Gustave ANGUILE ,<br />
            Immeuble Serena<br />
            B.P 3403<br />
            Email: contact@ccpsgabon.ga<br />
            Tel : +241 (0) 77 94 26 29
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
